import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'exceeded',
})
export class ExceededPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Yes' : 'No';
  }
}
